/**
 * useTranslationSync — synchronise i18next avec les traductions gérées en base.
 * À monter une seule fois (dans App) : couvre toute la plateforme.
 *
 * Les traductions de base sont bundlées (src/i18n/local) ; les valeurs gérées
 * dans le superadmin (table `translations`) viennent les surcharger au runtime.
 */
import { useEffect } from 'react';
import i18n from '@/i18n';
import { loadDbTranslations } from '@/lib/i18nDb';

export function useTranslationSync() {
  useEffect(() => {
    // Charge les éventuelles surcharges de la langue courante, puis
    // force un rafraîchissement pour que les libellés DB s'appliquent.
    const current = i18n.language || 'fr';
    loadDbTranslations(current).finally(() => {
      i18n.changeLanguage(current).catch(() => {});
    });

    const handler = (e: Event) => {
      const lang = (e as CustomEvent<{ lang?: string }>).detail?.lang;
      if (lang) loadDbTranslations(lang);
    };
    window.addEventListener('lang-changed', handler);
    return () => window.removeEventListener('lang-changed', handler);
  }, []);
}

export default useTranslationSync;